export default __webpack_public_path__ + "static/HomeBanner-cecff9240e8a51043de6b959b68aec1f.jpg";